import {
    CLAIMS_ENABLED,
    CLAIMS_UI_ROOT,
    DAF_UI_ROOT,
    FEE_FREE_BG_CODE,
    SUPPORT_CENTER_SEARCH_ENABLED,
    AUTHENTICATE_ENABLED,
    AUTHENTICATE_UI_ROOT,
} from 'gatsby-env-variables';

export const ALERT_TYPES = {
    GENERAL: 'general',
    EMERGENCY: 'emergency',
};

export const ALERT_IDS = 'alert_ids';

export const CONTENT_ONLY = 'contentonly';

export const APPLICATION_URL = DAF_UI_ROOT;
export const FEE_FREE_APP_URL = `${DAF_UI_ROOT}?bgCode=${FEE_FREE_BG_CODE}`;

export const SUPPORT_URL = '/help';

export const LEARNMORE_URL = '/bank-guarantee';

export const SEARCH_ENABLED = SUPPORT_CENTER_SEARCH_ENABLED;

export const CLAIMS_URL = CLAIMS_ENABLED ? CLAIMS_UI_ROOT : '/contact';

export const AUTHENTICATE_URL = AUTHENTICATE_ENABLED ? AUTHENTICATE_UI_ROOT : '/contact';